/* eslint-disable default-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ArrowLeftOutlined, EyeOutlined } from '@ant-design/icons';
import '../../../node_modules/simplebar/src/simplebar.css';
import './MasteryAssessment.css';
import './MasteryAnswer.css';

import ScrollViewQuestions from '../../components/ScrollViewQuestions';
import SlideViewQuestions from '../../components/SlideViewQuestions';

import { Button, Typography, Popconfirm, Modal, Row, Col, Segmented, Select, Space } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { useSelector } from 'react-redux';
import platform from 'platform';
import uuid from 'react-uuid';
import { isMobile } from 'react-device-detect';
import ReactHtmlParser from "react-html-parser";
import { stripQuillFormulaGuards } from '../../components/wysiwyg/quillFormulaGuard';

const { Text } = Typography;

export function MasteryAnswerManual(props) {
   let sectionIdx = 1;
   let qcardIdx = 1;
   let idxCol = [];

   const [swiperRef, setSwiperRef] = useState(null);
   const [isTransitioning, setIsTransitioning] = useState(false);
   const [swiperIndex, setSwiperIndex] = useState(0);
   const location = useLocation();
   const navigate = useNavigate();
   const assessmentInfo = location.state.assInfo;
   const assignInfo = location.state.assignInfo;
   const assessmentType = location.state.type;

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const masteryrec = useSelector(state => state.masteryrec);

   const origin = location.state.origin;
   const orig_question_sheet = assessmentInfo.Question_sheet;

   const [isSorted, setIsSorted] = useState(false);

   // Refs for question list items
   const questionRefs = useRef([]);

   const [answerSheetData, setAnswerSheetData] = useState(() => {
      const sequence_local = JSON.parse(localStorage.getItem(user_id + "_" + assessmentInfo.Id + "_my_sequence"));
      const tmpAssInfo = orig_question_sheet;

      if (sequence_local !== null) {
         for (var i = 0; i < sequence_local.length; i++) {
            tmpAssInfo[i].sequence_no = sequence_local[i];
         }
      } else {
         if (assignInfo.randomize_questions === 1) {
            var sequence_numbers = null;
            sequence_numbers = Utils.generateSequenceNumbers(tmpAssInfo.length);
            localStorage.setItem(user_id + "_" + assessmentInfo.Id + "_my_sequence", JSON.stringify(sequence_numbers));
            for (var ii = 0; ii < sequence_numbers.length; ii++) {
               tmpAssInfo[ii].sequence_no = sequence_numbers[ii];
            }
         }
      }

      return tmpAssInfo;
   });

   const [answerData, setAnswerData] = useState(() => {
      var ansLocal = JSON.parse(localStorage.getItem(user_id + "_" + assessmentInfo.Id + "_myanswers"));
      if (ansLocal !== null) {
         return ansLocal;
      } else {
         return initializeAnswerData(orig_question_sheet)
      }
   });

   const [startTime, setStartTime] = useState(() => {
      var timeStarted = JSON.parse(localStorage.getItem(user_id + "_" + assessmentInfo.Id + "_timestarted"));
      if (timeStarted !== null) {
         var val = timeStarted;
         return val;
      } else {
         var val = Date.now();
         localStorage.setItem(user_id + "_" + assessmentInfo.Id + "_timestarted", JSON.stringify(val));
         return Date.now();
      }
   });

   const [isSubmitted, setIsSubmitted] = useState(false);
   const [questionIndex, setQuestionIndex] = useState(1);
   const [instruction, setInstruction] = useState(null);
   const [openInstruction, setOpenInstruction] = useState(false);

   const [viewType, setViewType] = useState("slide");

   // Swiper slide change handler
   const handleSlideChange = (swiper) => {
      setSwiperIndex(swiper.activeIndex);
      setQuestionIndex(swiper.activeIndex + 1);
   };

   useEffect(() => {
      Utils.verifyJwt();

      answerSheetData.sort((a, b) => {
         return a.sequence_no - b.sequence_no;
      });

      answerData.sort((a, b) => {
         return a.sequence_no - b.sequence_no;
      });

      setIsSorted(true);

      var tmpInstruction = getInstruction(assessmentType);

      if (tmpInstruction !== '' && tmpInstruction !== null) {
         setInstruction(tmpInstruction);
         setOpenInstruction(true);
      }

   }, [assignInfo.id]);

   function initializeAnswerData(data) {
      let ansData = [];
      let tmpdata = {};
      var sequence_numbers = null;

      if (assignInfo.randomize_questions === 1) {
         sequence_numbers = JSON.parse(localStorage.getItem(user_id + "_" + assessmentInfo.Id + "_my_sequence"));
      }

      data.map(({ id, type, option_labels }, idx) => {
         if (type.includes("multiple") || type.includes("true_or_false")) {
            tmpdata = {
               "id": id,
               "type": type,
               "answer": setDefaultAnswers(type, option_labels.length),
               "idx": idx,
               "sequence_no": sequence_numbers !== null ? sequence_numbers[idx] : idx,
            }
         } else if (type === "short_answer") {
            tmpdata = {
               "id": id,
               "type": type,
               "answer": [""],
               "considered": "0",
               "idx": idx,
               "sequence_no": sequence_numbers !== null ? sequence_numbers[idx] : idx,
            }
         } else if (type.includes("matching_type")) {
            tmpdata = {
               "id": id,
               "type": type,
               "answer": setDefaultAnswers(type, option_labels.length),
               "considered": "0",
               "idx": idx,
               "sequence_no": sequence_numbers !== null ? sequence_numbers[idx] : idx,
            }
         }
         else {
            tmpdata = {
               "id": id,
               "type": type,
               "answer": [""],
               "idx": idx,
               "sequence_no": sequence_numbers !== null ? sequence_numbers[idx] : idx,
            }
         }

         ansData.push(tmpdata);
      });

      return ansData;
   }

   function setDefaultAnswers(type, options_length) {
      let retVal = [];
      var multiple = type.includes("multiple") || type.includes("true_or_false");
      var matching = type.includes('matching_type');

      if (multiple) {
         for (var i = 0; i < options_length; i++) {
            retVal.push("0");
         }
      }

      if (matching) {
         for (var i = 0; i < options_length; i++) {
            retVal.push("");
         }
      }

      return retVal;
   }

   function handleAnswerRequest(data, idx) {
      var ad = [...answerSheetData];
      var sad = [...answerData];

      // var multiple = ad[idx].type.includes("multiple") || ad[idx].type.includes("true_or_false");
      // var matching = ad[idx].type.includes("matching");

      var multiple = ["multiple", "true_or_false", "matching"].some(type => ad[idx].type.includes(type));

      ad[idx].answer = [];
      sad[idx].answer = [];

      if (multiple) {
         ad[idx].answer.push.apply(ad[idx].answer, data);
         sad[idx].answer.push.apply(sad[idx].answer, data);
      } else {
         ad[idx].answer[0] = data;
         sad[idx].answer[0] = data;
      }

      setAnswerSheetData(ad);
      setAnswerData(sad);

      localStorage.removeItem(user_id + "_" + assessmentInfo.Id + "_myanswers");
      localStorage.setItem(user_id + "_" + assessmentInfo.Id + "_myanswers", JSON.stringify(sad));

      sectionIdx = 1;
      qcardIdx = 1;
      idxCol = [];
   }

   const handleNavigate = () => {
      navigate(`/studentmasteryassessment/preview?assign_id=${assignInfo.id}&mastery_id=${masteryrec.id}&origin=${origin}&auto_proceed=${true}&qt=2`);
   }

   const handleSubmit = () => {
      setIsSubmitted(true);
      var o2o_mode = Utils.determineOnlineOffline();
      let timestampz = new Date().getTime();

      var question_seq = JSON.parse(localStorage.getItem(user_id + "_" + assessmentInfo.Id + "_my_sequence"));
      var answers = answerData.length > 0 ? answerData : JSON.parse(localStorage.getItem(user_id + "_" + assessmentInfo.Id + "_myanswers"));

      if (answers[0].idx !== undefined) {
         answers.sort((a, b) => {
            return a.idx - b.idx;
         });
      }

      var ansInfo = {
         Id: "ans_" + o2o_mode + "_" + uuid() + "_" + timestampz + "_" + user_id,
         Mastery_assessment_id: assessmentInfo.Id,
         Mastery_assignment_id: assignInfo.id,
         Student_id: user_id,
         User_agent: platform.ua,
         Browser: platform.name,
         Browser_version: platform.version,
         OS_platform: platform.os.family,
         Device: platform.product,
         Assessment_type: assessmentType,
         Answer: JSON.stringify(answers),
         Submit_status: 1,
         Score: 0,
         Essay_score: 0,
         Expiration: null,
         Status: -1,
         Question_sequence: question_seq !== null ? question_seq.join(',') : null,
      }

      const updateAnsUrl = `${process.env.REACT_APP_API_MASTERY_ASSESSMENT}/updateanswer?assessment_type=${assessmentType}&cache=${uuid()}`;
      axios.post(updateAnsUrl, ansInfo).then(response => {
         if (response.data) {
            const data = response.data;

            localStorage.removeItem(user_id + "_" + assessmentInfo.Id + "_timestarted");
            localStorage.removeItem(user_id + "_" + assessmentInfo.Id + "_myanswers");
            localStorage.removeItem(user_id + "_" + assessmentInfo.Id + "_my_sequence");

            setIsSubmitted(false);

            handleNavigate();
         }
      }, (error) => {
         setIsSubmitted(false);

         Modal.error({
            title: 'Mastery Assessment',
            content: error.response.data,
            centered: true
         });
      });

   }

   function getInstruction(formative_type) {
      var retVal = '';

      switch (formative_type) {
         case 'formative_1':
            retVal = masteryrec.formative_1_instruction;
            break;
         case 'formative_2':
            retVal = masteryrec.formative_2_instruction;
            break;
         case 'formative_3':
            retVal = masteryrec.formative_3_instruction;
            break;
         case 'summative':
            retVal = masteryrec.summative_instruction;
            break;
         default:
            retVal = '';
      }

      return retVal;
   }

   const handleGoTo = (value) => {
      const re = /^[0-9]+$/;

      if (re.test(value) || value === "") {
         setQuestionIndex(value);

         if (viewType === "scroll") {
            const idx = Number(value) - 1;
            if (questionRefs.current[idx]) {
               questionRefs.current[idx].scrollIntoView({ behavior: "smooth", block: "center" });
            }
         }

         if (swiperRef && swiperRef.slideTo) {
            swiperRef.slideTo(Number(value) - 1, 0);
         }
      }
   };

   const handlePrev = () => {
      if (swiperRef && swiperRef.slidePrev && !isTransitioning) {
         try {
            setIsTransitioning(true);
            swiperRef.slidePrev();
         } catch (e) {
            setIsTransitioning(false);
         }
      }
   };

   const handleNext = () => {
      if (swiperRef && swiperRef.slideNext && !isTransitioning) {
         try {
            setIsTransitioning(true);
            swiperRef.slideNext();
         } catch (e) {
            setIsTransitioning(false);
         }
      }
   };

   const handleChangeView = (val) => {
      setViewType(val);
      setQuestionIndex(1);
   }

   return (
      <>
         {
            isSorted &&
            <div className="dashboard-area-all" style={{ paddingRight: `0px` }}>
               <div className="dashboard-item">
                  <div className="dashboard-item-inner">
                     <ResponsiveBreadcrumb
                        items={[
                           ...(!isMobile
                              ? [
                                 { key: 'home', node: <Link to="/home">Home</Link> },
                                 { key: 'lms', node: 'Brainee LMS' },
                                 { key: 'mastery-assessment', node: <a href="#" onClick={() => navigate('/studentmasteryassessment', { state: { activetab: "1" } })}>Mastery Assessment</a> },
                              ]
                              : []),
                           {
                              key: 'start',
                              node: isMobile
                                 ? <a href="#" onClick={() => navigate(`/studentmasteryassessment/preview?origin=${origin}&qt=${assignInfo.mode}`)}><ArrowLeftOutlined />&nbsp;Start</a>
                                 : <a href="#" onClick={() => navigate(`/studentmasteryassessment/preview?origin=${origin}&qt=${assignInfo.mode}`)}>Start</a>
                           },
                           { key: 'assessment-type', node: Utils.GetTypeLabel(assessmentType) },
                        ]}
                     />

                     <div style={{ width: '100%', textAlign: 'center', marginBottom: "10px" }}>
                        <Space>
                           {instruction !== '' && instruction !== null ? <Button className='button-shadow' type='primary' shape='round' onClick={() => setOpenInstruction(true)}><EyeOutlined /> Instruction</Button> : <></>}
                           <Segmented
                              key={'uid'}
                              value={viewType}
                              options={[
                                 {
                                    label: 'Scroll',
                                    value: 'scroll',
                                    title: 'Scroll View',
                                 },
                                 {
                                    label: 'Slide',
                                    value: 'slide',
                                    title: 'Slide View',
                                 },
                              ]}
                              onChange={(val) => handleChangeView(val)}
                           />
                        </Space>
                     </div>
                  </div>

                  {
                     viewType === "scroll"
                        ? (
                           <ScrollViewQuestions
                              answerSheetData={answerSheetData}
                              answerData={answerData}
                              handleAnswerRequest={handleAnswerRequest}
                              questionRefs={questionRefs}
                              idxCol={idxCol}
                              sectionIdx={sectionIdx}
                              qcardIdx={qcardIdx}
                              location={location}
                              questionIndex={questionIndex}
                              handleGoTo={handleGoTo}
                              onQuestionIndexChange={setQuestionIndex}
                              isSubmitted={isSubmitted}
                              handleSubmit={handleSubmit}
                              Text={Text}
                              assessment_type={"mastery"}
                           />
                        )
                        : (
                           <SlideViewQuestions
                              answerSheetData={answerSheetData}
                              answerData={answerData}
                              handleAnswerRequest={handleAnswerRequest}
                              swiperRef={setSwiperRef}
                              handleSlideChange={handleSlideChange}
                              setIsTransitioning={setIsTransitioning}
                              isTransitioning={isTransitioning}
                              idxCol={idxCol}
                              sectionIdx={sectionIdx}
                              qcardIdx={qcardIdx}
                              location={location}
                              questionIndex={questionIndex}
                              handleGoTo={handleGoTo}
                              isSubmitted={isSubmitted}
                              handleSubmit={handleSubmit}
                              handlePrev={handlePrev}
                              handleNext={handleNext}
                              assessment_type={"mastery"}
                           />
                        )
                  }
               </div>
            </div>
         }

         <Modal
            key="Modal-Instruction"
            title={<>Instruction</>}
            destroyOnClose={true}
            centered
            open={openInstruction}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ shape: 'round', type: 'primary', className: "button-shadow" }}
            onCancel={() => setOpenInstruction(false)}
            onOk={() => setOpenInstruction(false)}
            okText="Ok"
            cancelText="Close"
            width={"55%"}
            style={{ minWidth: "350px", maxWidth: "95%" }}
         >
            <div
               // dangerouslySetInnerHTML={{ __html: getInstruction(assessmentType) }}
               style={{ textOverflow: 'ellipsis', overflow: 'auto', backgroundColor: '#FFF', maxHeight: '300px', padding: '10px', borderRadius: '7px' }}
            >
               {ReactHtmlParser(stripQuillFormulaGuards(getInstruction(assessmentType)))}
            </div>
         </Modal>
      </>
   )
}

